
<template>
    <div>
      <div class="flex">
        <div class="leftbox">
            <div class="menu flex-ctr" :class="{ 'active-menu': tab === 1 }" @click="tabChange(1)">
                <img :src="tab == 1 ? require('@/assets/images/icon8.png') : require('@/assets/images/icon8-1.png')" alt="">
                专题课程
            </div>
            <div class="line"></div>
            <div class="menu flex-ctr" :class="{ 'active-menu': tab === 2 }" @click="tabChange(2)">
                <img :src="tab == 2 ? require('@/assets/images/icon10.png') : require('@/assets/images/icon10-1.png')" alt="">
                推荐课程
            </div>
        </div>
        <div class="rightbox">
            <template v-if="tab == 1">
                <div class="mb-30" v-for="(e,i) in tableData.records" :key="i">
                    <div class="title cp" @click="toPage(e)">{{e.title}}</div>
                    <div class="table">
                        <div class="head">
                            <div class="flex-3">课程名称</div>
                            <div>主讲人</div>
                            <div>学习进度</div>
                            <div>学时</div>
                            <div class="flex-2">开始时间</div>
                            <div class="flex-2">结束时间</div>
                            <div>操作</div>
                        </div>
                        <div class="">
                            <div class="table-row" v-for="(c) in e.resources" :key="c.id">
                                <div class="flex-3">{{c.name}}</div>
                                <div>{{c.speaker}}</div>
                                <div>{{c.progress}}%</div>
                                <div>{{c.hours}}</div>
                                <div class="flex-2">{{e.startTime |dateFormat('yyyy.MM.dd HH:mm:ss')}}</div>
                                <div class="flex-2">{{e.endTime |dateFormat('yyyy.MM.dd HH:mm:ss')}}</div>
                                <div>
                                    <div class="table-btn" @click="toStudy(c)">继续学习</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <el-pagination @current-change="handleCurrentChange" background :current-page.sync="query.current"
                    :page-size="10" layout="prev, pager, next, jumper" :total="tableData.total">
                </el-pagination>
            </template>
            <template v-if="tab == 2">
                <div class="mb-30">
                    <div class="table">
                        <div class="head">
                            <div class="flex-3">课程名称</div>
                            <div>主讲人</div>
                            <div>学习进度</div>
                            <div>学时</div>
                            <div class="flex-2">开始学习时间</div>
                            <div class="flex-2">最近学习时间</div>
                            <div>操作</div>
                        </div>
                        <div class="">
                            <div class="table-row" v-for="(e,i) in tableData2.records" :key="i">
                                <div class="flex-3">{{e.name}}</div>
                                <div>{{e.speaker}}</div>
                                <div>{{e.progress||0}}%</div>
                                <div>{{e.hours}}</div>
                                <div class="flex-2">{{e.startTime|dateFormat('yyyy.MM.dd HH:mm:ss')}}</div>
                                <div class="flex-2">{{e.lastTime|dateFormat('yyyy.MM.dd HH:mm:ss')}}</div>
                                <div>
                                    <div class="table-btn" @click="toStudy(e)">继续学习</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <el-pagination @current-change="handleCurrentChange" background :current-page.sync="query.current"
                    :page-size="10" layout="prev, pager, next, jumper" :total="tableData2.total">
                </el-pagination>
            </template>
        </div>
      </div>
    </div>
  </template>
  
  <script>
import { list, progresssave,courselist } from "@/api/ztxm.js";
export default {
    data() {
      return {
        tab: 1,
        query: {
            current: 1,
            size: 10
        },
        tableData: { //表格数据
            total: 0,
            records: []
        },
        tableData2: { //表格数据
            total: 0,
            records: []
        }
      }
    },
    created() {
        if(this.$route.query.tab){
            this.tab=this.$route.query.tab
        }
        this.getList()
    },
    methods: {
      handleCurrentChange(val) {
        this.query.current = val
        this.getList()
      },
      getList(pageNumber, pageSize) {
        this.query.current = pageNumber || this.query.current
        this.query.size = pageSize || this.query.size
        if(this.tab==1){
            list(this.query).then(res => {
                this.tableData = res
            })
        }else{
            courselist(this.query).then(res => {
                this.tableData2 = res
            })
        }
        
      },
      tabChange(t){
        this.tab=t
        this.query.current = 1
        this.getList()
      },
      toStudy(e){
        this.$router.push({
                path: '/myTrain/course',
                query: {
                    id: e.id,
                }
            })
        
      },
      toPage(e){
        this.$router.push({
                path: '/myTrain/detail',
                query: {
                    id: e.id,
                }
            })
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .leftbox {
    background-color: #fff;
    padding: 30px;

    .menu {
        font-weight: 400;
        font-size: 16px;
        color: #1A1A1A;
        padding: 0 5px 22px 5px;
        cursor: pointer;

        &:last-child {
            padding-bottom: 0;
        }

        img {
            width: 18px;
            height: 18px;
            margin-right: 4px;
        }
    }

    .active-menu {
        font-weight: 700;
        color: #E4381D;
    }

    .line {
        height: 2px;
        background: #EEEEEE;
        border-radius: 2px 2px 2px 2px;
        margin-bottom: 22px;
    }
  }

  .rightbox {
    margin-left: 20px;
    background-color: #fff;
    padding: 24px;
    flex: 1;

    .title {
        display: inline-block;
        position: relative;
        font-weight: 700;
        font-size: 18px;
        line-height: 22px;
        color: #E4381D;
        padding-left: 15px; 
        margin-bottom: 20px;

        &::before{
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 5px;
            height: 16px;
            background: linear-gradient( 270deg, #E4381D 0%, #D81D10 100%);
            border-radius: 0px 0px 0px 0px;
        }

        &::after{
            content: '';
            position: absolute;
            bottom: 0;
            left: 15px;
            width: calc(100% - 15px);
            height: 1px;
            background: linear-gradient( 270deg, #E4381D 0%, #D81D10 100%);
        }
    }

    .table {
        font-size: 14px;
        line-height: 20px;
        text-align: center;
        border-right: 1px solid #E3E3E3;
        border-bottom: 1px solid #E3E3E3;

        .head {
            display: flex;
            background: #EEEEEE;
            border-top: 1px solid #E3E3E3;
            border-left: 1px solid #E3E3E3;

            div {
                flex: 1;
                border-right: 1px solid #E3E3E3;
                padding: 10px 0;

                &:last-child {
                    border-right: none;
                }
            }

            .flex-2 {
                flex: 2;
            }

            .flex-3 {
                flex: 3;
            }
        }

        .table-row {
            display: flex;

            >div {
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 15px 0;
                border-top: 1px solid #E3E3E3;
                border-left: 1px solid #E3E3E3;
            }

            .flex-2 {
                flex: 2;
            }

            .flex-3 {
                flex: 3;
            }

            .table-btn {
                width: 74px;
                line-height: 24px;
                background: linear-gradient( 147deg, #F59A23 0%, #FF901A 98%);
                border-radius: 3px 3px 3px 3px;
                font-size: 14px;
                color: #FFFFFF;
                cursor: pointer;
            }
        }
    }
  }
  
  </style>
  